module.exports = __webpack_public_path__ + "img/03_slip_felt_technics1.8688a8a5.png";